import { ModalPropsMap } from '@/legacy/types';

export type ModalType = keyof ModalPropsMap;

export type ModalSlice = {
	modalType: ModalType | null;
	modalProps: ModalType extends keyof ModalPropsMap
		? ModalPropsMap[ModalType]
		: Record<string, any>;
	openModal: <T extends ModalType>(type: T, props: ModalPropsMap[T]) => void;
	updateModalProps: (id: string, partial: any) => void;
	closeModal: () => void;
	resetModalSlice: () => void;
};

const initialModalState: Pick<ModalSlice, 'modalType' | 'modalProps'> = {
	modalType: null,
	modalProps: {},
};

export const createModalSlice = (set: (fn: (state: any) => any) => void): ModalSlice => ({
	...initialModalState,
	openModal: (type, props) =>
		set((state) => ({
			...state,
			modalType: type,
			modalProps: props,
		})),
	updateModalProps: (id, partial) =>
		set((state) => {
			if (state.modalType !== id) return state;
			return {
				...state,
				modalProps: {
					...state.modalProps,
					...partial,
				},
			};
		}),

	closeModal: () =>
		set((state) => ({
			...state,
			modalType: null,
			modalProps: {},
		})),

	resetModalSlice: () => set(() => initialModalState),
});
